/** @jsx jsx */
import { useRef, useState } from 'react';
import { jsx, Layout as BaseLayout, Main } from 'theme-ui';
import { Global } from '@emotion/core';
import global from '~theme/global';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { MainContainer } from '../MainContainer';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Layout = function Layout(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var nav = useRef();
  return jsx(BaseLayout, {
    sx: {
      '& > div': {
        flex: '1 1 auto'
      }
    },
    "data-testid": "layout"
  }, jsx(Global, {
    styles: global
  }), jsx(Main, {
    sx: styles.main
  }, jsx(Header, {
    onOpen: function onOpen() {
      return setOpen(function (s) {
        return !s;
      });
    }
  }), jsx("div", {
    sx: styles.wrapper
  }, jsx(Sidebar, {
    ref: nav,
    open: open,
    onFocus: function onFocus() {
      return setOpen(true);
    },
    onBlur: function onBlur() {
      return setOpen(false);
    },
    onClick: function onClick() {
      return setOpen(false);
    }
  }), jsx(MainContainer, {
    "data-testid": "main-container"
  }, children))));
};

if (typeof Layout !== 'undefined' && Layout && Layout === Object(Layout) && Object.isExtensible(Layout) && !Layout.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Layout, '__filemeta', {
    configurable: true,
    value: {
      name: "Layout",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Layout/index.js"
    }
  });
}